/**
 * 字典常量 //science_tech_area:科技领域  hnkjtarea：行政区划 platform_type：平台类型
 */
let dictConst={
    // 科技领域
    techDomain:"science_tech_area",
	//成果阶段
	fruitPhase:"fruit_stage_type",
	//转化方式
	translateType:"fruit_translate_way",
	//意向价格
	intentionPrice:"INTENTION_PRICE",
    //行政区划
    region:"hnkjtarea",
    //湖南省行政区域代码
    regionHunanCode:"430000",
    platformType:"platform_type",
    //平台所属园区
    platformPark:"hnkjt_fullpark"
}
export default dictConst
